import React from 'react';
import styles from './TaskCard.module.scss';
import classnames from 'classnames';
import { useLanguage } from '../../contexts/LanguageContext';

interface TaskCardProps {
    title: string;
    description: string;
    buttonText: string;
    buttonLink: string;
    completed: boolean;
    isPartner?: boolean;
}

export default function TaskCard({ 
    title, 
    description, 
    buttonText, 
    buttonLink, 
    completed,
    isPartner = false
}: TaskCardProps) {
    const { t } = useLanguage();
    
    const handleClick = () => {
        if (buttonLink.startsWith('http') && !completed) {
            window.open(buttonLink, '_blank');
        }
    };

    return (
        <div 
            className={classnames(
                styles.task, 
                completed ? styles.completed : '',
                isPartner ? styles.partner : ''
            )}
            onClick={handleClick}
        >
            {completed && <div className={styles.task__check_icon}>✓</div>}
            <div className={styles.task__content}>
                <h3 className={styles.task__title}>
                    {title}
                    {isPartner && <span className={styles.task__partner_badge}>{t('taskcard.partner_days')}</span>}
                </h3>
                <p className={styles.task__description}>{description}</p>
            </div>
            <div className={styles.task__actions}>
                {completed ? (
                    <div className={styles.task__completed_badge}>{t('taskcard.completed')}</div>
                ) : (
                    <button 
                        className={classnames(styles.task__button, isPartner ? styles.task__button_partner : '')}
                        onClick={(e) => {
                            e.stopPropagation(); // Предотвращаем срабатывание клика на родительском элементе
                            handleClick();
                        }}
                    >
                        {buttonText}
                    </button>
                )}
            </div>
        </div>
    );
} 